import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Play icon for media playback
 */
export const PlayIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </Icon>
  );
};

export default PlayIcon;
